import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {TipoArrotondamento} from "@commons/mapping/TurnoDistribuzioneRecord";
import {UserTrace} from "@commons/types";


export type TimbratureCompensabili = "TUTTE" | "PRIMA_ULTIMA" | "SINGOLA_COPIA";
export type RegolaFlex = "RITARDO_RECUPERATO" | "FINO_A_CAPIENZA" | "ANCHE_FUORI_LIMITE" | "ADEGUA_USCITA";

interface FlexRecBase {
    negativa: number;
    positiva: number;
}

export interface ScartiFlex extends FlexRecBase {
}

export interface FlexRecord extends URIAndTrace {
    idAziendaTabelle: number;
    idFlex: number;
    descrizione: string,
    abilitaFlex: boolean;
    abilitaFlexPausa: boolean;
    timbPausaInizio: number;
    timbPausaFine: number;
    pausaMin: number;
    pausaMax: number;
    timbratureCompensabili: TimbratureCompensabili;
    regolaFlex: RegolaFlex;
    scarti: ScartiFlex[];
    prioritaSuToll: number;
    tipoArrotondamento: TipoArrotondamento
    idTabArrotondamenti: number;
    insertTrace: UserTrace;
    lastUpdateTrace: UserTrace;
}

export class FlexRecord {
    static isArrotondamentoDaTabella = (that: FlexRecord) => that.tipoArrotondamento === 'DA_TABELLA';
    static getMinArrotondamento = function (that: FlexRecord) {
        if (that.tipoArrotondamento === 'DA_TABELLA') {
            return 1;
        } else if (that.tipoArrotondamento === 'AL_QUARTO') {
            return 15;
        } else if (that.tipoArrotondamento === 'ALLA_MEZZA') {
            return 30;
        } else if (that.tipoArrotondamento === 'AL_DECIMO') {
            return 10;
        } else if (that.tipoArrotondamento === 'AL_QUINTO') {
            return 5;
        } else {
            return 1; // MINUTARIO
        }
    };
    static isTrasversale = function (that: FlexRecord) {
        return (that.timbratureCompensabili === 'TUTTE');// || that.timbratureCompensabili === 'PRIMA_ULTIMA');
    };

    static getScarti = function (that: FlexRecord) {
        var flexScarti = [];
        if (that.timbratureCompensabili === 'PRIMA_ULTIMA') {
            flexScarti.push(that.scarti[0]);
            flexScarti.push(that.scarti[3]);
        } else {
            flexScarti = that.scarti;
        }
        return flexScarti;
    };

    static isIngressoInFlex = function (that: FlexRecord, scartoSuBase: number) {
        return scartoSuBase >= 0 && scartoSuBase <= that.scarti[0].negativa;
    }
}